import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { MonitorSmartphone, User, Lock, Loader2 } from 'lucide-react';

export default function MitarbeiterLogin() {
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await fetch('/api/auth/employee/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier, password }),
      });
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem('tester_token', data.access_token);
        if (data.status === 'pending_interview') {
          navigate('/mitarbeiter/pending');
        } else {
          navigate('/mitarbeiter/dashboard');
        }
      } else {
        setError(data.detail || 'Ungültige Zugangsdaten');
      }
    } catch (err) {
      setError('Netzwerkfehler. Bitte prüfen Sie die Verbindung zum Server.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-primary px-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-2xl p-8">
        <div className="flex flex-col items-center mb-8">
          <MonitorSmartphone className="w-12 h-12 text-accent mb-4" />
          <h1 className="text-2xl font-bold text-primary">Tester Login</h1>
          <p className="text-sm text-muted-foreground text-center mt-2">Willkommen zurück im Netzwerk für digitale Qualitätssicherung</p>
        </div>
        {error && (
          <div className="bg-red-50 text-red-600 p-3 rounded-md text-sm mb-4 text-center border border-red-200">
            {error}
          </div>
        )}
        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-secondary mb-1">Tester-ID oder E-Mail</label>
            <div className="relative">
              <User className="w-5 h-5 text-slate-400 absolute left-3 top-2.5" />
              <input
                type="text"
                required
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                className="w-full pl-10 p-2.5 border border-border rounded focus:ring-accent focus:border-accent outline-none"
                placeholder="E-Mail oder RMD-1001"
                disabled={loading}
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-secondary mb-1">Passwort</label>
            <div className="relative">
              <Lock className="w-5 h-5 text-slate-400 absolute left-3 top-2.5" />
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 p-2.5 border border-border rounded focus:ring-accent focus:border-accent outline-none"
                placeholder="••••••••"
                disabled={loading}
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-accent text-white py-3 rounded-md font-medium hover:bg-accent/90 transition-colors flex items-center justify-center gap-2 disabled:opacity-70"
          >
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : null}
            {loading ? 'Logge ein...' : 'Einloggen & Aufträge prüfen'}
          </button>
        </form>
        <div className="mt-6 text-center border-t border-border pt-6">
          <p className="text-sm text-muted-foreground">
            Noch kein Tester? <Link to="/karriere" className="text-accent font-medium hover:underline">Hier bewerben</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
